import { createApp } from 'vue';
import App from './App.vue';
import './styles/theme.scss';

createApp(App).mount('#app');
